/**
 * @generated SignedSource<<0edf1430a0532a02ad4062356a0f7115>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AlertEventGroupInvestigationStatus = "FAILED" | "INVESTIGATED" | "INVESTIGATING" | "STALE" | "UNINVESTIGATED" | "%future added value";
export type AlertEventGroupSeverity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type AlertEventGroupStatus = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AlertGroupContextBanner_alertEventGroup$data = {
  readonly eventCount: number;
  readonly firstSeenAt: any;
  readonly id: string;
  readonly impactSummary: string | null | undefined;
  readonly investigationCount: number;
  readonly investigationDetails: ReadonlyArray<{
    readonly alertAgentName: string | null | undefined;
    readonly createdAt: any;
    readonly id: string;
    readonly name: string;
    readonly status: string;
    readonly teamName: string | null | undefined;
  }>;
  readonly investigationStatus: AlertEventGroupInvestigationStatus | null | undefined;
  readonly label: string;
  readonly lastSeenAt: any;
  readonly rootCauseSummary: string | null | undefined;
  readonly severity: AlertEventGroupSeverity | null | undefined;
  readonly status: AlertEventGroupStatus;
  readonly " $fragmentType": "AlertGroupContextBanner_alertEventGroup";
};
export type AlertGroupContextBanner_alertEventGroup$key = {
  readonly " $data"?: AlertGroupContextBanner_alertEventGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertGroupContextBanner_alertEventGroup">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AlertGroupContextBanner_alertEventGroup",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "severity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "investigationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "investigationCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstSeenAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastSeenAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootCauseSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impactSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAlertEventGroupInvestigation",
      "kind": "LinkedField",
      "name": "investigationDetails",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alertAgentName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLAlertEventGroupSummary",
  "abstractKey": null
};
})();

(node as any).hash = "853058289164f4c3f1f7ad5feb1de7c0";

export default node;
